import { Injectable } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { AzureDevOpsMembershipResponse, CarvanaAzureActiveDirectoryResponse } from '../models/membership-response';
import { PlatformPortalApiService } from './platform-portal-api.service';

@Injectable({
  providedIn: 'root'
})
export class MembershipService {
  private readonly adoMembershipCache = new Map<string, Observable<AzureDevOpsMembershipResponse>>();
  private readonly carvanaAdMembershipCache = new Map<string, Observable<CarvanaAzureActiveDirectoryResponse>>();
  constructor(private readonly platformPortalApiService: PlatformPortalApiService) {}

  /**
   * Retrieves Azure DevOps membership information
   * @param org - The organization name (e.g., 'adesacentral')
   * @returns Observable<AzureDevOpsMembershipResponse>
   */
  getAzureDevOpsMembership(org: string): Observable<AzureDevOpsMembershipResponse> {
    if (!this.adoMembershipCache.has(org)) {
      const membership$ = this.platformPortalApiService.getMembership<AzureDevOpsMembershipResponse>(org, 'AzureDevOps.json').pipe(
        shareReplay(1)
      );
      this.adoMembershipCache.set(org, membership$);
    }
    return this.adoMembershipCache.get(org)!;
  }

  /**
   * Retrieves Carvana Azure AD membership information
   * @param org - The organization name (e.g., 'adesacentral')
   * @returns Observable<CarvanaAzureActiveDirectoryResponse>
   */
  getCarvanaADMembership(org: string): Observable<CarvanaAzureActiveDirectoryResponse> {
    if (!this.carvanaAdMembershipCache.has(org)) {
      const membership$ = this.platformPortalApiService.getMembership<CarvanaAzureActiveDirectoryResponse>(org, 'CarvanaAzureActiveDirectory.json').pipe(
        shareReplay(1)
      );
      this.carvanaAdMembershipCache.set(org, membership$);
    }
    return this.carvanaAdMembershipCache.get(org)!;
  }
} 